import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import Products from './pages/Products';
import ProductForm from './pages/ProductForm';
import PriceUpdates from './pages/PriceUpdates';
import PagePlaceholder from './pages/PagePlaceholder';
import HomePageEditor from './pages/HomePageEditor';
import AboutPageEditor from './pages/AboutPageEditor';
import ContactPageEditor from './pages/ContactPageEditor';
import RFQPageEditor from './pages/RFQPageEditor';
import ProductPageEditor from './pages/ProductPageEditor';
import GlobalSections from './pages/GlobalSections';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#fff',
                color: '#374151',
                borderRadius: '0.75rem',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
              },
              success: {
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
              },
              error: {
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
          
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="categories" element={<Categories />} />
              <Route path="products" element={<Products />} />
              <Route path="products/new" element={<ProductForm />} />
              <Route path="products/edit/:id" element={<ProductForm />} />
              <Route path="price-updates" element={<PriceUpdates />} />
              <Route path="global-sections" element={<GlobalSections />} />
              <Route path="pages/home" element={<HomePageEditor />} />
              <Route path="pages/about" element={<AboutPageEditor />} />
              <Route path="pages/contact" element={<ContactPageEditor />} />
              <Route path="pages/rfq" element={<RFQPageEditor />} />
              <Route path="pages/products" element={<ProductPageEditor />} />
              <Route path="pages/:pageName" element={<PagePlaceholder />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;